import { connect } from 'react-redux';
import IsiNilaiEkskul from '../../../views/Student/ekskul/IsiNilaiEkskul.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(IsiNilaiEkskul);


